import translations, { ICombinedTranslations } from '../translations';

export const getPersonalNumberPlaceholder = (locale: keyof ICombinedTranslations) =>
  translations[locale].components.personalNumber.placeholder ||
  translations['en-SE'].components.personalNumber.placeholder;

export const getCompanyNumberPlaceholder = (locale: keyof ICombinedTranslations) =>
  translations[locale].components.orgNumber.placeholder ||
  translations['en-SE'].components.orgNumber.placeholder;
